// ============================================================
// types/competencia.types.ts — Competencias y notas
// ============================================================

export interface CompetenciaPayload {
  cursoId: number;
  nombre: string;
  descripcion?: string;
  orden: number;
}

export interface CompetenciaResponse {
  idCompetencia: number;
  cursoId: number;
  cursoNombre: string;
  nombre: string;
  descripcion: string | null;
  orden: number;
  activo: boolean;
}

export type CalificacionLetra = 'AD' | 'A' | 'B' | 'C';

export interface NotaCompetenciaItem {
  competenciaId: number;
  calificacion: CalificacionLetra;
  conclusionDescriptiva: string | null;
}

export interface NotaCompetenciaMasivoPayload {
  matriculaId: number;
  periodoId: number;
  calificaciones: NotaCompetenciaItem[];
}

export interface NotaCompetenciaResponse {
  idNotaCompetencia: number;
  competenciaId: number;
  competenciaNombre: string;
  cursoId: number;
  cursoNombre: string;
  matriculaId: number;
  estudianteId: number;
  estudianteNombres: string;
  estudianteApellidos: string;
  periodoId: number;
  periodoNombre: string;
  calificacion: CalificacionLetra;
  conclusionDescriptiva: string | null;
  fechaRegistro: string;
}

export const CALIFICACION_COLOR: Record<CalificacionLetra, string> = {
  AD: 'bg-blue-100 text-blue-700',
  A:  'bg-green-100 text-green-700',
  B:  'bg-amber-100 text-amber-700',
  C:  'bg-red-100 text-red-700',
};

export const CALIFICACION_LABEL: Record<CalificacionLetra, string> = {
  AD: 'AD — Logro Destacado',
  A:  'A — Logro Esperado',
  B:  'B — En Proceso',
  C:  'C — En Inicio',
};
